import $ from 'jquery';
import 'slick-carousel'

let mediaSlider = {
  initialize: function () {
    document.querySelectorAll('.js-media-slider-container').forEach(slider => {
      $(slider).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: true,
        appendDots: slider.closest('.js-media-slider').querySelector('.js-media-slider-dots'),
        fade: true
      });
    });
  }
};

mediaSlider.initialize();
